<template>
    <div v-if="firstStep">
        <el-scrollbar class="equipment_scroll">
            <div class="equipment_edit">
                <formCreate v-model="fApi" :rule="rule" :option="options" class="leader-style-form"></formCreate>
            </div>
        </el-scrollbar>
        <div slot="footer" class="dialog-footer footer">
            <el-button aligen="center" plain @click="onReset(false)" class="leader-common-button">取消</el-button>
            <el-button v-if="hasNext" class="leader-common-button" @click="goSecond(false)">下一步</el-button>
            <el-button v-else @click="onSubmit" type="primary" class="leader-common-button">保存</el-button>
        </div>
    </div>
    <EquipmentAddB
        v-else
        :from="1"
        :shebeiChecklist="shebeiChecklist"
        :currentTreeNode="currentTreeNode"
        :currentTreeTypeId="currentTreeTypeId"
        :firstStepData="firstStepData"
        :secondStepData="secondStepData"
        @changePage="goFirst"
        @closeDialog="onReset(true)"
    ></EquipmentAddB>
</template>
<script>
import * as api from '../../api/index';
import formCreate from '@form-create/element-ui';
import EquipmentAddB from './equipment_add_b.vue';
export default {
    components: {
        formCreate: formCreate.$form(),
        EquipmentAddB: EquipmentAddB,
    },
    props: {
        addColumn: Object,
        currentTreeNode: Object,
    },
    data() {
        return {
            hasNext: false,
            firstStep: true,
            firstStepData: {},
            currentTreeNode: this.currentTreeNode,
            addColumn: this.addColumn,
            shebeiChecklist: [],
            secondStepData: { tableData: [], checkList: [] },
            fApi: {},
            options: {
                submitBtn: false,
                resetBtn: false,
            },
            rule: [],
            currentTreeTypeId: '',
        };
    },
    watch: {
        addColumn(val) {
            this.rule = [];
            //第一遍循环：按顺序生成表单
            for (let item of val) {
                if (item.colum_type == 'select') {
                    if (!item.need_colum_id) {
                        if (
                            item.colum_id == 'cq_000005' ||
                            item.colum_id == 'cq_000003' ||
                            item.colum_id == 'pdbyq_000003'
                        ) {
                            this.rule.push({
                                type: 'select',
                                field: item.colum_id,
                                title: item.colum_title,
                                value: '',
                                disabled: false,
                                select: null,
                                options: [],
                                col: {
                                    span: 12,
                                    labelWidth: 120,
                                },
                                props: {
                                    multiple: false,
                                    disabled: false,
                                },
                                inject: true,
                                on: {
                                    change: this.changeTreeType,
                                },
                                validate: [
                                    {
                                        required: item.colum_required == '1',
                                        message: '请选择' + item.colum_title,
                                    },
                                ],
                            });
                        } else {
                            this.rule.push({
                                type: 'select',
                                field: item.colum_id,
                                title: item.colum_title,
                                value: '',
                                disabled: false,
                                select: null,
                                options: [],
                                col: {
                                    span: 12,
                                    labelWidth: 120,
                                },
                                props: {
                                    multiple: false,
                                    disabled: false,
                                },
                                inject: true,
                                on: {
                                    change: this.change,
                                },
                                validate: [
                                    {
                                        required: item.colum_required == '1',
                                        message: '请选择' + item.colum_title,
                                    },
                                ],
                            });
                        }
                    } else {
                        this.rule.push({
                            type: 'select',
                            field: item.colum_id,
                            title: item.colum_title,
                            value: '',
                            select: item.need_colum_id,
                            options: [],
                            col: {
                                span: 12,
                                labelWidth: 120,
                            },
                            props: {
                                multiple: false,
                                disabled: false,
                            },
                            inject: true,
                            on: {
                                change: this.change,
                                'visible-change': this.visibleChange,
                            },
                            validate: [
                                {
                                    required: item.colum_required == '1',
                                    message: '请选择' + item.colum_title,
                                },
                            ],
                        });
                    }
                } else if (item.colum_type == 'date') {
                    this.rule.push({
                        type: 'DatePicker',
                        field: item.colum_id,
                        title: item.colum_title,
                        props: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            placeholder: `请选择${item.colum_title}`,
                            disabled: false,
                        },
                        col: {
                            span: 12,
                            labelWidth: 120,
                        },
                        validate: [
                            {
                                required: item.colum_required == '1',
                                message: '请选择' + item.colum_title,
                            },
                        ],
                    });
                } else if (item.colum_type == 'text') {
                    this.rule.push({
                        type: 'input',
                        field: item.colum_id,
                        title: item.colum_title,
                        value: '',
                        props: {
                            maxlength: item.max_length,
                            disabled: false,
                        },
                        col: {
                            span: 12,
                            labelWidth: 120,
                        },
                        validate: [
                            {
                                required: item.colum_required == '1',
                                message: '请输入' + item.colum_title,
                                trigger: 'blur',
                            },
                        ],
                    });
                } else if (item.colum_type == 'radio') {
                    this.rule.push({
                        type: 'radio',
                        field: item.colum_id,
                        title: item.colum_title,
                        value: '0',
                        disabled: false,
                        options: [
                            { value: '0', label: '否', disabled: false },
                            { value: '1', label: '是', disabled: false },
                        ],
                        props: {
                            disabled: false,
                        },
                        col: {
                            span: 12,
                            labelWidth: 120,
                        },
                        validate: [
                            {
                                required: item.colum_required == '1',
                                message: '请选择' + item.colum_title,
                            },
                        ],
                    });
                }
            }
            //第二遍循环：生成options，复制给select类型的表单项
            for (let item of val) {
                if (item.colum_type == 'select') {
                    if (!item.need_colum_id) {
                        if (
                            item.colum_id == 'cq_000005' ||
                            item.colum_id == 'cq_000003' ||
                            item.colum_id == 'pdbyq_000003'
                        ) {
                            api.getSelectTwo({
                                tree_level: this.currentTreeNode.tree_level,
                            }).then((res) => {
                                const options = [];
                                res.bus_json.forEach((item, index) => {
                                    options.push({
                                        value: item.tree_type_id,
                                        label: item.tree_type_name,
                                        disabled: false,
                                        is_go: item.is_go,
                                    });
                                });
                                this.rule.forEach((_item, _index) => {
                                    if (item.colum_id == _item.field) {
                                        _item.options = options;
                                    }
                                });
                            });
                        } else {
                            api.getSelect({
                                colum_id: item.colum_id,
                            }).then((res) => {
                                const options = [];
                                res.bus_json.forEach((item, index) => {
                                    options.push({
                                        value: item.code_value,
                                        label: item.code_name,
                                        disabled: false,
                                    });
                                });
                                this.rule.forEach((_item, _index) => {
                                    if (item.colum_id == _item.field) {
                                        _item.options = options;
                                    }
                                });
                            });
                        }
                    }
                }
            }
        },
    },
    methods: {
        onSubmit() {
            this.fApi.submit((formData, $f) => {
                const treeColumList = [];
                for (var key in formData) {
                    treeColumList.push({
                        colum_id: key,
                        colum_value: formData[key],
                    });
                }
                api.docInsert({
                    p_tree_id: this.currentTreeNode.tree_id,
                    // tree_name: this.currentTreeNode.tree_name,
                    tree_level: this.currentTreeNode.tree_level,
                    tree_type_id: this.currentTreeTypeId,
                    treeColumList: treeColumList,
                    deviceList: [],
                }).then((res) => {
                    this.$emit('closeDialog', true);
                });
            });
        },
        onReset(flag) {
            this.$emit('closeDialog', flag);
        },
        changeTreeType(inject) {
            //可能有下一步的下拉框
            this.hasNext = false;
            let self = inject.self;
            self.options.forEach((item, index) => {
                if (
                    item.value == self.value &&
                    item.is_go &&
                    item.is_go == '1' &&
                    this.currentTreeNode.tree_level == '30'
                ) {
                    this.hasNext = true;
                    api.getTreeTypeRelation({
                        tree_type_id: self.value,
                    }).then((res) => {
                        this.shebeiChecklist = res.bus_json;
                    });
                }
            });
            this.currentTreeTypeId = self.value;
            //初始化下级下拉框
            this.resetVal(inject.self.field, inject.rule);
            //查询下级下拉框的options
            this.queryCascadeOptions(inject);
            this.$emit('changeTitle', this.hasNext);
        },
        change(inject) {
            //初始化下级下拉框
            this.resetVal(inject.self.field, inject.rule);
            //查询下级下拉框的options
            this.queryCascadeOptions(inject);
        },
        queryCascadeOptions(inject) {
            this.addColumn.forEach((item, index) => {
                if (item.need_colum_id == inject.self.field) {
                    //======查询接口
                    api.getSelect({
                        colum_id: item.colum_id,
                        p_code_value: inject.self.value,
                    }).then((res) => {
                        const options = [];
                        res.bus_json.forEach((item, index) => {
                            options.push({
                                value: item.code_value,
                                label: item.code_name,
                                disabled: false,
                            });
                        });
                        inject.rule[index].options = options;
                    });
                }
            });
        },
        resetVal(colum_id, rules) {
            if (colum_id && rules) {
                for (const key in rules) {
                    if (rules[key].select && rules[key].select == colum_id) {
                        let item = rules[key];
                        this.$set(item, 'value', '');
                        this.$set(item, 'options', []);
                        this.resetVal(rules[key].field, rules);
                    }
                }
            }
        },
        goSecond() {
            this.fApi.submit((formData, $f) => {
                this.firstStepData = formData;
                this.firstStep = false;
                this.$emit('emitDataChange', {
                    add_title: '设备新增-第2/2步:选择柜内设备',
                });
            });
        },
        goFirst(secondStepData) {
            this.firstStep = true;
            this.secondStepData = secondStepData;
        },
        visibleChange(inject, flag) {
            if (flag) {
                this.addColumn.forEach((item, index) => {
                    if (
                        inject.self.select == item.colum_id &&
                        !this.fApi.form[item.colum_id]
                    ) {
                        this.$message({
                            type: 'info',
                            message: '请先选择' + item.colum_title,
                        });
                    }
                });
            }
        },
    },
};
</script>
